import { iconDefaults, type IconProps } from './Icon'

export function MarkIcon(props: IconProps) {
  return (
    <svg {...iconDefaults} {...props}>
    <path d="M12 3 4 7v5c0 5 3.4 8.4 8 9 4.6-.6 8-4 8-9V7l-8-4Z" />
    <path d="M9 12.2l2.2 2.2L15.4 10" />
    </svg>
  )
}
